import { createAsyncThunk } from "@reduxjs/toolkit";
import classesService from "../../../api/services/classes";

export const deletePeriod = createAsyncThunk(
  "period/deletePeriod",
  async (periodId) => {
    return await classesService.deletePeriod(periodId);
  }
);

export const createPeriod = createAsyncThunk(
  "period/createPeriod",
  async (periodData) => {
    return await classesService.createPeriod(periodData);
  }
);
